// extracted by mini-css-extract-plugin
export default {"container":"IMChat_container__MygP4","render-btn-wrap":"IMChat_render-btn-wrap__ASGyo"};